import React from 'react'

import footerAnimation from '../Assets/ainfra/animation/footer_animation.gif'
import logoAnimation from '../Assets/ainfra/animation/logo_anim.gif'
import { Link, useLocation } from 'react-router-dom'
import { backurl } from '../Config/env'

const FooterNew = () => {
    const location = useLocation().pathname

    console.log('locationcheck', location === '/launchpad')


    return (
        <footer className='aif-footer__section'>
            <div className={`${location === '/' ? ' lnd-container' : "container ai-container"}`}>
                <div className='d-flex align-items-center aif-footer__row'>

                    <div className='aif-footer order-2 order-lg-1'>
                        <div className='aif-footer__left '>
                            {/* <div className='aif-footer__left-content'>
                                <Link to='/ai-compute' className='aif-footer__title'>AI Compute</Link>
                                <p className='aif-footer__desc'>Decentralized AI Computation</p>
                            </div> */}
                            <div className='aif-footer__left-content'>
                                <Link to='/storage' className='aif-footer__title'>Storage</Link>
                                <p className='aif-footer__desc'>Fast, Reliable and Secure</p>
                            </div>
                            <div className='aif-footer__left-content'>
                                <Link to='/depin' className='aif-footer__title'>DePIN</Link>
                                <p className='aif-footer__desc'>AInfra Rewards</p>
                            </div>
                            <div className='aif-footer__left-content'>
                                <Link target={'_blank'} to={`${backurl + '/Images/' + "AInfra_Wp.pdf"}`} className='aif-footer__title'>White Paper</Link>
                            </div>
                        </div>
                        <div className='aif-footer__right '>
                            {/* <Link to='/' className='aif-footer__title'>Ecosystem</Link>
                            <div>
                                <Link to='/' className='aif-footer__title'>Release</Link>
                            </div> */}
                            <div className='aif-footer__right-anim'>
                                <img src={footerAnimation} className='' />
                            </div>
                        </div>
                    </div>
                    <img src={logoAnimation} className='aif-footer__logo-anim order-1 order-lg-2' />


                </div>
                <p className='text-center aif-footer__copyright'>© 2024 AInfra Network. All rights reserved.</p>
            </div>
        </footer>
    )
}

export default FooterNew